import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from '@/views/Dashboard.vue';
import VueRouter from 'vue-router';
import store from '@/store/store';
store.commit('initialiseStore');
Vue.use(Router);

const routes = [
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/',
        name: 'Inloggen',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(/* webpackChunkName: "login" */ '@/views/Login.vue')
    },
    {
        path: '/accountaanmaken',
        name: 'Account aanmaken',
        component: () =>
            import(/* webpackChunkName: "register" */ '@/views/Register.vue')
    },
    {
        path: '/wachtwoordvergeten',
        name: 'Wachtwoord vergeten',
        component: () =>
            import(
                /* webpackChunkName: "ResetPassword" */ '@/views/ResetPassword.vue'
            )
    },
    {
        path: '/wachtwoordinstellen',
        name: 'Wachtwoord instellen',
        component: () =>
            import(
                /* webpackChunkName: "SetPassword" */ '@/views/SetPassword.vue'
            )
    }
];

const router = new VueRouter({ routes: routes });

router.beforeEach((to, from, next) => {
    const isLoggedIn = store.getters.getLoggedInState;
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!isLoggedIn) {
            // Gebruiker is nog niet ingelogd:
            next({ name: 'Inloggen' });
        } else {
            next(); // go to wherever I'm going
        }
    } else {
        next(); // does not require auth, make sure to always call next()!
    }
});
export default router;
